// extracted by mini-css-extract-plugin
export default {"money-input":"style_money-input__Pyur7__WHx6O","money-description":"style_money-description__9pFk4__WHx6O"};